<div class="flex gap-4 items-center">
  <span class="content-center border-solid border-2 rounded-lg px-2 py-4 overflow-x-auto">{{ copyText }}</span>
  <button type="button" mat-flat-button class="w-auto button-primary" [cdkCopyToClipboard]="copyText" (click)="notifyUser()">
    <mat-icon matSuffix class="material-icons-outlined !m-0" matRipple>content_copy</mat-icon>
    <span>{{ copyButtonLabel }}</span>
  </button>
</div>
